/**
 * @fileoverview Barrel exports for the chapter-drafter-comparison-v2 COMPOSITE agent.
 *
 * This is a composite agent that runs chapter-drafter-v2 in parallel with
 * different models for comparison purposes.
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitive has its own prompt)
 * - flow.ts: Parallel orchestration logic using executeParallel
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  ComparisonItemSchema,
  type Input,
  type Output,
  type HookInput,
  type ComparisonItem,
} from './schema';

// Flow
export { flow, chapterDrafterComparisonV2AgentFlow } from './flow';

